var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": "Request an invite", role: "dialog" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v("Request an invite"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row margin-15-bottom" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("i", [
            _vm._v(
              "\n                You can request an invite from this group admin to join this group and sign up to multi me if you\n                haven’t already.\n                "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n                Please read the groups ‘About Page’ membership information to see if you qualify to join this group.\n                If you send a request then please include a message to the admin that says who you are and why you\n                would like to join this group.\n            "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row margin-15-bottom" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            ref: "emailField",
            staticClass: "form-control",
            attrs: {
              type: "email",
              required: "",
              placeholder: "Your email",
              "aria-label": "Your email",
            },
            domProps: { value: _vm.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row margin-15-bottom" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.message,
                expression: "message",
              },
            ],
            staticClass: "form-control",
            attrs: {
              required: "",
              name: "message",
              id: "message",
              rows: "10",
              placeholder: "Message to Group Admin",
            },
            domProps: { value: _vm.message },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.message = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-mm btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.close },
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-mm btn-green",
            attrs: { type: "button", disabled: !_vm.readyToSent },
            on: { click: _vm.send },
          },
          [_vm._v("\n            Send Request\n        ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }